<template>
    <div>
        <div role="button" @click="toggleInvitedEmails()" class="d-flex justify-content-end w-100">
            {{ trans(`general.invite.invited_x_emails_${scope}`, {x: invitedEmailsList.length}) }}
            <i :class="['ms-1 fi', showEmails ? 'fi-rr-angle-small-up' : 'fi-rr-angle-small-down']"></i>
        </div>
        <div v-if="showEmails" class="scrollable my-2" style="max-height: 150px; overflow-y: auto;">
            <div class="item px-3 py-1 bg-gray-100 border-radius mb-1" v-for="item in invitedEmailsList">
                {{ item.email }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            scope: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                showEmails: false,
                invitedEmailsList: []
            }
        },
        watch: {
            invitedEmailsList() {
                this.$emit('invitedEmailsList', this.invitedEmailsList);
            }
        },
        methods: {
            toggleInvitedEmails() {
                this.showEmails = !this.showEmails;
            },
            fetchInvitedEmails() {
                let params = {
                    roles: this.scope === 'employee' ? ['administrator', 'teacher'] : ['parent'],
                };

                axios.get(`/space/forms/space-form-invitations/get-by-scopes`, {params})
                    .then(response => {
                        this.invitedEmailsList = response.data.data;
                    })
            }
        },
        mounted() {
            this.fetchInvitedEmails();
        },
    }
</script>
